export function getCookie(name) {
  const nameEQ = name + "=";
  const decodedCookie = document.cookie; //decodeURIComponent(document.cookie);
  const parts = decodedCookie.split(";");
  for (let i = 0; i < parts.length; i++) {
    let part = parts[i].trim();
    if (part.indexOf(nameEQ) === 0) {
      // console.log(
      //   "get",
      //   JSON.parse(
      //     decodeURIComponent(part.substring(nameEQ.length, part.length))
      //   )
      // );
      return JSON.parse(
        decodeURIComponent(part.substring(nameEQ.length, part.length))
      );
    }
  }
  return null;
}
export function logout() {
  setCookie("kungfu", null, 0);
  setCookie("name", null, 0);
  //console.log("logout");
  window.location.reload();
}
export function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();
  // console.log(value);
  // console.log(`${name}=${JSON.stringify(value)};${expires};path=/`);
  document.cookie = `${name}=${encodeURIComponent(
    JSON.stringify(value)
  )};${expires};path=/`;
}
